import { ButtonOptions } from "ui-pixijs";
import { ScaleUpButton } from "../../common/components/buttons/ScaleUpButton";
import { TextStyle } from "@pixi/text";
import { getDefaultFontFamily } from "../../common/TextUtils";
import { LocalizedText } from "../../common/components/LocalizedText";
import { Localization } from "../../common/Localization";
import { AudioManager } from "../../../audio/AudioManager";

export class RetryButton extends ScaleUpButton {
    private retryText: LocalizedText;

    public constructor(
        options: ButtonOptions,
        private readonly localization: Localization,
        audioManager: AudioManager
    ) {
        super(options, audioManager);
        this.build();
        this.layout();
    }

    private build(): void {
        this.retryText = new LocalizedText("restart", this.localization, new TextStyle({
            fontFamily: getDefaultFontFamily(),
            fontSize: 36,
            fill: "#AA6B00",
            align: 'left'
        }), 215, 85);
        this.retryText.anchor.set(0.5);
        this.addChild(this.retryText);

    }

    private layout(): void {
        this.retryText.position.set(155, 50);
    }
}